import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AlertWarning = ({
  warningMessage,
  show = false,
}: { warningMessage: string, show: boolean }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className={classnames([
        'alert',
        'show',
        'alert-warning',
      ])} role="alert"
    >
      {warningMessage}
    </div>
  );
};

AlertWarning.propTypes = {
  show: PropTypes.bool,
  warningMessage: PropTypes.string.isRequired,
};

export default AlertWarning;
